import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Grid from "../../../components/grid";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_LISTAR_NUEVO } from "../../../utils/const/estilos-const";
import ModalConfirmar from "../../../components/modal-confirmar";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import SinAccesoCard from "../../../components/sin-acceso-card";
import { sharedNextPage } from "../../../utils/shared-functions";
import { deshabilitarImagenEmpresa, obtenerListaImagenEmpresa, removeDefaultImagenEmpresa, setDefaultImagenEmpresa } from "../../../api/imagen-empresa";
import { useTranslation } from "react-i18next";
import { COLOR_AZUL_MAIN } from "../../../utils/const/colors-const";
import { STRING_COLOR_PRIMARIO } from "../../../utils/const/string-const";



export default function GestionarLogo() {
  const { t } = useTranslation();
  const headers = [
    { key: "acciones", title: t('column_acciones') },
    { key: "id", title: "ID", visible: false, },
    { key: "nombreImagen", title: t('column_nombre'), visible: true, filter: true, editLabel: true, },
    { key: "default", title: "DEFAULT", visible: false, filter: true, editLabel: true, },
    { key: "defaultLabel", title: "DEFAULT", visible: true, filter: true, editLabel: true, },
    { key: "urlImagen", title: "URL", visible: true, filter: true, editLabel: true, },
    { key: "fechaProceso", title: t('column_fecha_proceso'), visible: true, filter: true },
  ];
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [listElements, setListElements] = useState([]);
  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
  const [modalSetDefault, setModalSetDefault] = useState(false);
  const [modalRemoveDefault, setModalRemoveDefault] = useState(false);
  const [colorMain, setColorMain] = useState(COLOR_AZUL_MAIN);
  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      /*let obj = {};
      obj.idMenuPrimerNivel = INT_ID_MODULO_CHECKLIST;
      obj.idMenuSegundoNivel = INT_ID_SEGUNDO_NIVEL_ADMINISTRACION_CHECKLIST;
      obj.idMenuTercerNivel = INT_ID_TERCER_NIVEL_CHECKLIST_OPCIONES_RESPUESTA;
      let obtenerPermisos = await obtenerPermisosPorNivelUsuarioWeb(obj);
      let permiso = obtenerPermisos[0];
      setPermisos(permiso);
      */
      let permiso = null;
      let lista = [];

      // if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
      // accesoBotonNuevo = '';
      setTieneAccesoAlModulo(true);
      lista = await obtenerListaImagenEmpresa(false);
      // }
      // if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
      //   if (permiso.accesoAlModulo === TRUE) {
      //     setTieneAccesoAlModulo(true);
      //     lista = await getListCurrencies(false);
      //   }
      // }
      const colorBase = localStorage.getItem(STRING_COLOR_PRIMARIO);
      if (colorBase !== null) {
        setColorMain(colorBase);
      }

      agregarAccionesALista(lista, permiso);
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const agregarAccionesALista = (lista, permiso) => {
    try {
      // console.log('agregarAccionesALista');
      // console.log(lista);

      const objDeshabilitar = {
        label: t('btn_deshabilitar'),
        color: "red",
        onClick: (param) => changeStatus(param),
      };
      const objSetDefault = {
        label: t('btn_set_default'),
        color: "green",
        onClick: (param) => changeSetDefault(param),
      };
      const objRemoveDefault = {
        label: t('btn_remove_default'),
        color: "green",
        onClick: (param) => changeRemoveDefault(param),
      };
      // if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
      // if (permiso.nuevo === TRUE) {
      // accesoBotonNuevo = '';
      // }
      // }
      for (let i = 0; i < lista.length; i++) {
        let acciones = [];
        // if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        // acciones.push(objModificar);          
        acciones.push(objDeshabilitar);
        if (lista[i].default === 0) {
          acciones.push(objSetDefault);
        }
        if (lista[i].default === 1) {
          acciones.push(objRemoveDefault);
        }
        // }
        // if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        // if (permiso.modificar === TRUE) {
        // acciones.push(objModificar);
        // }
        // if (permiso.eliminarDeshabilitar === TRUE) {
        // acciones.push(objDeshabilitar);
        // }
        // }
        lista[i].acciones = acciones;
      }
      setListElements(lista);

    } catch (err) {
      console.log('agregarAccionesALista err');
      console.log(err);
    }
  }

  const changeStatus = (data) => {
    try {
      console.log("changeStatus");
      console.log(data);
      setElementoSelected(data);
      setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("changeStatus err");
      console.log(err);
    }
  };

  const changeSetDefault = (data) => {
    try {
      console.log("changeSetDefault");
      console.log(data);
      setElementoSelected(data);
      setModalSetDefault(true);
    } catch (err) {
      console.log("changeSetDefault err");
      console.log(err);
    }
  };

  const changeRemoveDefault = (data) => {
    try {
      console.log("changeSetDefault");
      console.log(data);
      setElementoSelected(data);
      setModalRemoveDefault(true);
    } catch (err) {
      console.log("changeSetDefault err");
      console.log(err);
    }
  };

  const handleNuevoClick = () => {
    // console.log("handleNuevoClick");
    let obj = {};
    let data = {};
    data.id = 0;
    data.name = "";
    data.url = "";

    obj.title = t('titulo_nuevo_logo');
    obj.params = data;
    sharedNextPage("logo", obj, history);
  }

  const handleAtrasClick = () => {
    history.goBack();
  }

  const handleCancelModal = () => {
    setModalConfirmarDeshabilitarVisible(false);
  }

  const handleConfirmModal = async () => {
    setModalConfirmarDeshabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      const disabled = await deshabilitarImagenEmpresa(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (disabled === true) {
        alert(t('alert_se_elimino_correctamente'));
        reset();
      }
      if (disabled === false) {
        alert(t('alert_no_se_pudo_eliminar'));
      }
    }
  }

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const handleConfirmSetDefault = async () => {
    setModalSetDefault(false);
    if (elementoSelected == null) {
      return;
    }
    // console.log('elementoSelected');
    // console.log(elementoSelected);
    // return;
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      const disabled = await setDefaultImagenEmpresa(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (disabled === true) {
        alert(t('alert_se_selecciono_como_default_correctamente'));
        reset();
      }
      if (disabled === false) {
        alert(t('alert_no_se_pudo_realizar_el_cambio'));
      }
    }
  };

  const handleRemoveDefault = async () => {
    setModalRemoveDefault(false);
    if (elementoSelected == null) {
      return;
    }
    // console.log('elementoSelected');
    // console.log(elementoSelected);
    // return;
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      const disabled = await removeDefaultImagenEmpresa(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (disabled === true) {
        alert('Se cambio estado correctamente');
        reset();
      }
      if (disabled === false) {
        alert('No se pudo realizar el cambio');
      }
    }
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return SinAccesoCard();
      }
      return (
        <div>
          <div className="pt-4 px-4 flex justify-between">
            <label
              style={{
                paddingLeft: 10,
                fontWeight: 'bold',
              }}
            >
              {t('titulo_gestionar_logo')}
            </label>
            <div className="flex justify-center">
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_NUEVO}
                onClick={handleNuevoClick}
                style={{
                  backgroundColor: colorMain,
                  marginRight: '2px'
                }}
              >
                {t('btn_nuevo')}
              </button>
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={handleAtrasClick}
                style={{
                  marginRight: '2px'
                }}
              >
                {t('btn_atras')}
              </button>
            </div>
          </div>
          <Grid rows={listElements} headers={headers} />
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={handleCancelModal}
            onConfirm={handleConfirmModal}
            message={t('alert_esta_seguro_de_eliminar_imagen')}
          />
          <ModalConfirmar
            isOpen={modalSetDefault}
            onCancel={() => { setModalSetDefault(false) }}
            onConfirm={handleConfirmSetDefault}
            message={t('alert_esta_seguro_de_seleccionar_como_imagen_principal_default')}
          />
          <ModalConfirmar
            isOpen={modalRemoveDefault}
            onCancel={() => { setModalRemoveDefault(false) }}
            onConfirm={handleRemoveDefault}
            message={t('alert_esta_seguro_de_quitar_imagen_principal_default')}
          />
        </div>
      );
    } catch (err) {
      console.log('ManageCurrency render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
